/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSWinLineBuilder.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */
namespace WinAnimation.Line {
    /**
   * WinLineBuilder class is used to handle all common mehtods for desktop and mobile versions
   * @author <a href=mailto:snethani@gauselmann.com>Sujata Nethani</a>
   * @version $Revision: 1.0 $ $Date:  3 July 2020 $
   */
    export class BSWinLineBuilder extends WinLineBuilder {
        public createWinLine(lineId: number, frameSheetId?: string, frameId?: number | string): BSWinLine {
            const line = new BSWinLine(lineId);
            line.frameSpriteSheetId = frameSheetId;
            line.frameSpriteId = frameId;
            return line;
        }
        public createLeftTag(line: BSWinLine, x: number, y: number, key: string, frame?: number | string): Tag {
            line.leftTag = this.createTag(line, x, y, key, frame)
            return line.leftTag;
        }
        public createRightTag(line: BSWinLine, x: number, y: number, key: string, frame?: number | string): Tag {
            line.rightTag = this.createTag(line, x, y, key, frame);
            return line.rightTag;
        }
        private createTag(line: BSWinLine, x: number, y: number, key: string, frame?: number | string): Tag {
            const tag_normal = this.game.add.sprite(0, 0, key, frame + '_01');
            const tag_greyed = this.game.add.sprite(0, 0, key, frame + '_01');
            const tag_lit = this.game.add.sprite(0, 0, key, frame + '_03');
            const tag = new BSTag(this.game.add.group(null, 'BSLineTag'), tag_normal, tag_greyed, tag_lit);
            tag.getView().x = x;
            tag.getView().y = y;
            return tag;
        }
    }
}